import React, {PropTypes} from 'react';
import LocationItem from './LocationItem.jsx';

const LocationsPanel = ({
  locationName,
  locations,
  locationSearchResults,
  saveable,
  selectable,
  onAddLocationClick,
  onCancelClick,
  onCenterChange,
  onLocationNameChange,
  onRemoveClick,
  onSaveClick,
  onSearchClick
}) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <h4 className="panel-title">        
        <span>{'Locations'}
          <button type="button"
            className="btn btn-link pull-right"
            onClick={onAddLocationClick}>
            <i className="fa fa-plus"/> {'Add Location'}
          </button>
        </span>
      </h4>
    </div>
    <div className="panel-body">
      <div className="list-group">
        {locations.map((item, index) => (
          <LocationItem key={index}
            {...item}
            locationName={locationName}
            locationSearchResults={locationSearchResults}
            saveable={saveable}
            selectable={selectable}
            onCancelClick={onCancelClick}
            onCenterChange={onCenterChange}
            onLocationNameChange={onLocationNameChange}
            onRemoveClick={onRemoveClick}
            onSaveClick={onSaveClick}
            onSearchClick={onSearchClick}
          />
        ))}
      </div>
    </div>
  </div>
);

LocationsPanel.propTypes = {
  locationName: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object),
  locationSearchResults: PropTypes.arrayOf(PropTypes.object),
  saveable: PropTypes.bool,
  selectable: PropTypes.bool,
  onAddLocationClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onCenterChange: PropTypes.func,
  onLocationNameChange: PropTypes.func,
  onRemoveClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onSearchClick: PropTypes.func
};

LocationsPanel.defaultProps = {
  locations: []
};

export default LocationsPanel;


// WEBPACK FOOTER //
// ./src/features/tournament/general/LocationsPanel.jsx